/* eslint-disable import/prefer-default-export */
/**
 * Using k/w to compact big number
 * @param {Number} number
 */
export function compactNumber(number) {
  if (typeof number !== 'number') return '';
  if (number < 1000) return `${number}`;
  if (number < 10000) return `${(Math.floor(number / 100) / 10).toFixed(1)}K`;
  if (number < 100000) return `${(Math.floor(number / 1000) / 10).toFixed(1)}W`;
  return `${Math.floor(number / 10000)}W`;
}

export function compactNumberNoK(number) {
  if (typeof number !== 'number') return '';
  if (number < 10000) return `${number}`;
  if (number < 100000) return `${(Math.floor(number / 1000) / 10).toFixed(1)}W`;
  return `${Math.floor(number / 10000)}W`;
}
